import { VIDEO_EVENTS } from 'playable';
const frameRate = 1000 / 30;
export class FBWrapper {
  constructor(player) {
    this.player = player;
  }
  on(event, cb) {
    switch (event) {
      case VIDEO_EVENTS.CURRENT_TIME_UPDATED:
        this.onTimeUpdate(cb);
        break;
      case VIDEO_EVENTS.ERROR:
        this.onErrorHandler(cb);
        break;
      default:
        throw new Error(`event ${event} not supported`);
    }
  }
  destroy() {}
  getCurrentTime() {
    return this.player.getCurrentPosition();
  }
  getDuration() {
    return this.player.getDuration();
  }
  onTimeUpdate(cb) {
    let timerId = null;
    const cancelTimer = () => {
      if (timerId) {
        window.clearTimeout(timerId);
        timerId = null;
      }
    };
    const progressUpdate = isPlaying => {
      const duration = this.getDuration();
      const seconds = this.getCurrentTime();
      const percent = duration > 0 ? seconds / duration : 0;
      cb({
        duration,
        percent,
        seconds
      });
      if (isPlaying) {
        timerId = window.setTimeout(progressUpdate, frameRate, isPlaying);
      } else {
        cancelTimer();
      }
    };
    this.player.subscribe('startedPlaying', () => {
      progressUpdate(true);
    });
    this.player.subscribe('paused', () => {
      progressUpdate(false);
    });
    this.player.subscribe('finishedPlaying', () => {
      progressUpdate(false);
    });
  }
  onErrorHandler(cb) {
    this.player.subscribe('error', e => {
      cb(e);
    });
  }
}
//# sourceMappingURL=FBWrapper.js.map